module.exports = __webpack_public_path__ + "static/appbase.78b56509.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/examples/thumbnails/appbase.jpg
// module id = 838
// module chunks = 73261030922168